<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col
                class="pb-1 pt-2"
                cols="8"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.procedimento"
                            :requestQueryStringParams="autocompleteRequestParams.procedimento"
                            :searchFields="fields.procedimento"
                            :text-field="p => `${formatProcedimento(p.codigo)} - ${p.nome}`"
                            :validations="validations.procedimentoId"
                            label="Procedimento"
                            v-model="model.procedimento"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group v-model="additionals.searchByApelido">
                                        <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                        <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :searchFields="fields.cid"
                            :repository="repositories.cid"
                            :requestQueryStringParams="autocompleteRequestParams.cid"
                            :disabled="!model.procedimento"
                            :validations="validations.cidPrincipalId"
                            :text-field="c => `${formatCid(c.codigo)} - ${c.nome}`"
                            label="CID Principal"
                            placeholder="Digite o código ou o nome do CID principal"
                            v-model="model.cidPrincipal"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-col>

            <rkm-col
                class="rkm-col"
                cols="4"
            >
                <div class="cbo">
                    <span>CBO</span>
                    <strong>{{ model.lotacao.ocupacao.codigo }}</strong>
                    <strong>{{ model.lotacao.ocupacao.nome }}</strong>
                </div>

                <div
                    v-if="model.procedimento"
                    class="procedimento mt-4"
                >
                    <span>PROCEDIMENTO</span>
                    <strong>{{ formatProcedimento(model.procedimento.codigo) }}</strong>
                    <strong>{{ model.procedimento.nome }}</strong>
                </div>

                <div
                    v-if="model.cidPrincipal"
                    class="cid mt-4"
                >
                    <span>CID PRINCIPAL</span>
                    <strong>{{ formatCid(model.cidPrincipal.codigo) }}</strong>
                    <strong>{{ model.cidPrincipal.nome }}</strong>
                </div>

                <rkm-row
                    v-if="model.procedimento"
                    class="mt-4 mb-1"
                >
                    <rkm-col>
                        <rkm-form-input
                            :validations="validations.quantidade"
                            label="Quantidade"
                            type="number"
                            v-model="model.quantidade"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, formats } from '@/mixins'

//Enums
import procedimento from '@/enums/sigtap/procedimento'

export default {
    computed: {
        autocompleteRequestParams() {
            return {
                procedimento: {
                    cbo_lotacao_atual: true,
                    paciente_id: this.data.form.paciente.id,
                    where_not: {
                        'codigo': [
                            this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL,
                            this.enums.procedimento.GLICEMIA_CAPILAR,
                            this.enums.procedimento.ATEND_URG_ATENCAO_PRIMARIA_OBS_ATE_8_HORAS,
                            this.enums.procedimento.ATEND_URG_OBS_ATE_24_HORAS_ATENCAO_ESPECIALIZADA,
                        ]
                    },
                    search_by_apelido: this.additionals.searchByApelido,
                },
                cid: this.model.procedimento && this.model.procedimento.hasCidPrincipal
                    ? {
                        principal: true,
                        procedimento_id: this.model.procedimento.id,
                    }
                    : {}
            }
        },
        fields() {
            return {
                procedimento: this.additionals.searchByApelido
                    ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                    : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                cid: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            }
        },
        validations() {

            let quantidade = { required: true, min_value: 1}

            if (this.quantidadeMaximaExecucao !== null) {

                quantidade.max_value = this.quantidadeMaximaExecucao
            }

            return {
                procedimentoId: { required: true },
                cidPrincipalId: { required: !!this.model.procedimento && !!this.model.procedimento.hasCidPrincipal },
                quantidade: quantidade,
            }
        }
    },
    created() {
        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            cid: this.getConectaSusRepository('sigtap.cid'),
        }
    },
    data: () => ({
        additionals: {
            searchByApelido: false,
        },
        enums: { procedimento },
        quantidadeMaximaExecucao: null,
    }),
    methods: {
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    const duplicado = this.data.model.procedimentos.find(item => {
                        if (item.id !== this.model.id) {
                            return item.procedimento.id === this.model.procedimento.id
                        }

                        return false
                    })

                    if (duplicado) {

                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: `Procedimento ${this.model.procedimento.codigo} já incluído para esse CBO ${this.model.lotacao.ocupacao.codigo}.`
                        })

                    } else {

                        if (this.model.id) {
                            const index = this.data.model.procedimentos.findIndex(item => item.id === this.model.id)
                            Object.assign(this.data.model.procedimentos[index], this.model)
                        } else {
                            this.model.id = this.uniqueId('pronto-atendimento-procedimento')
                            this.data.model.procedimentos.push(this.model)
                        }

                        this.$emit('saved', this.model)
                    }
                }
            })
        },
    },
    mixins: [repository, formats],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'model.procedimento': function (item) {

            this.quantidadeMaximaExecucao = item ? item.quantidadeMaximaExecucao : null
            this.model.cidPrincipal = null
        }
    }
}
</script>

<style scoped>
.rkm-col {
    background-color: #f8f9fa;
}
.cbo * {
    display: block;
}
.procedimento * {
    display: block;
}
.cid * {
    display: block;
}
</style>